import React from 'react';
import classNames from 'classnames';
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGripVertical } from '@fortawesome/pro-solid-svg-icons';

import style from './style.module.scss';

const MODEL_LABELS = {
  'google-gemini-3-pro-image-preview': 'Google Gemini 3 Pro Image Preview',
  'google-gemini-3-1-flash-image-preview': 'Google Gemini 3.1 Flash Image Preview',
  'replicate-google-gemini-3-pro-image-preview': 'Replicate Google Gemini 3 Pro Image Preview',
  'replicate-google-gemini-3-1-flash-image-preview': 'Replicate Google Gemini 3.1 Flash Image Preview',
  'replicate-bytedance-seedream-5-lite': 'Replicate Bytedance Seedream 5 Lite',
};

const PriorityOrderItem = ({
  item,
  index,
  onToggleEnabled,
  dragHandleProps,
  innerRef,
  draggableProps,
}) => (
  <div
    ref={innerRef}
    {...draggableProps}
    {...dragHandleProps}
    className={classNames(
      'd-flex align-items-center justify-content-between',
      'list-group-item list-group-item-action py-2 small',
    )}
  >
    <div className="d-flex align-items-center flex-grow-1">
      <span className="mr-2 text-muted">{`${index + 1}.`}</span>
      <span>{MODEL_LABELS[item.key] || item.key}</span>
    </div>
    {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
    <label className="switcher mr-2">
      <input
        type="checkbox"
        checked={item.enabled}
        className="switcher-input"
        onMouseDown={(e) => e.stopPropagation()}
        onChange={(e) => onToggleEnabled(index, e.target.checked)}
        aria-label={`Toggle ${MODEL_LABELS[item.key] || item.key}`}
      />
      <span className="switcher-indicator">
        <span className="switcher-yes" />
        <span className="switcher-no" />
      </span>
    </label>
    <span className="text-muted" title="Drag to reorder">
      <FontAwesomeIcon icon={faGripVertical} size="sm" />
    </span>
  </div>
);

const PriorityOrder = ({ value = [], onChange }) => {
  const onDragEnd = (result) => {
    const { destination, source } = result;
    if (!destination || destination.index === source.index) return;
    const next = [...value];
    const [removed] = next.splice(source.index, 1);
    next.splice(destination.index, 0, removed);
    onChange(next);
  };

  const onToggleEnabled = (index, enabled) => {
    onChange(value.map((item, i) => (i === index ? { ...item, enabled } : item)));
  };

  return (
    <div className={style.priorityOrderBlock}>
      <h6>Priority Order</h6>
      <p className="small text-muted mb-2">
        Drag to reorder. Models are tried in this order for fallbacks. Toggle to
        enable or disable each model.
      </p>
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="priority-order">
          {(droppableProvided) => (
            <div
              ref={droppableProvided.innerRef}
              {...droppableProvided.droppableProps}
            >
              {value.map((item, index) => (
                <Draggable
                  key={item.key}
                  draggableId={item.key}
                  index={index}
                >
                  {(draggableProvided) => (
                    <PriorityOrderItem
                      item={item}
                      index={index}
                      onToggleEnabled={onToggleEnabled}
                      innerRef={draggableProvided.innerRef}
                      draggableProps={draggableProvided.draggableProps}
                      dragHandleProps={draggableProvided.dragHandleProps}
                    />
                  )}
                </Draggable>
              ))}
              {droppableProvided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </div>
  );
};

export default PriorityOrder;
